import React from 'react';
import { Box } from '@mui/material';

export default function SubAccordionIconWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        borderRadius: '6px',
        display: 'flex',
        width: '50px',
        height: '50px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );
}
